import { Id } from '@/infra/id'
import type {
  ProvidedProfile,
  ProvidedTaxRefundMethod,
} from './supporting-item-input'

/**
 * A supporting item input proto that is provided with a profile version.
 */
interface ProvidedProfileInputProto {
  getProfileId(): { getValue(): string } | undefined
  getProfileVersion(): { getValue(): number } | undefined
}

/**
 * A supporting item input proto that is provided with a tax refund method
 * version.
 */
interface ProvidedTaxRefundMethodInputProto {
  getRefundMethodId(): { getValue(): string } | undefined
  getRefundMethodVersion(): { getValue(): number } | undefined
}

/**
 * Maps the profile version an input was provided with, `null` when it has
 * none yet.
 *
 * @param input
 */
export function mapProvidedProfileProtoToProps(
  input: ProvidedProfileInputProto,
): ProvidedProfile | null {
  const profileId = input.getProfileId()?.getValue()
  return profileId
    ? {
        profileId: Id(profileId),
        profileVersion: input.getProfileVersion()?.getValue() ?? 0,
      }
    : null
}

/**
 * Maps the tax refund method version an input was provided with, `null` when
 * it has none yet.
 *
 * @param input
 */
export function mapProvidedTaxRefundMethodProtoToProps(
  input: ProvidedTaxRefundMethodInputProto,
): ProvidedTaxRefundMethod | null {
  const refundMethodId = input.getRefundMethodId()?.getValue()
  return refundMethodId
    ? {
        refundMethodId: Id(refundMethodId),
        refundMethodVersion: input.getRefundMethodVersion()?.getValue() ?? 0,
      }
    : null
}
